import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TopStatusBar from '../components/topStatus/TopStatusBar';
import { Button } from 'antd-mobile';
import { RightOutline } from 'antd-mobile-icons';
import TopAiHelloCard from '../components/top-bg-card/TopAiHelloCard';
import UrgentTaskCard from '../components/index-display-components/UrgentTaskCard';
import ToAdminFixedBtn from '../../../components/ToAdminEntry/ToAdminFixedBtn';

interface Task {
  id: string;
  title: string;
  description: string;
  dateRange: string;
  image: string;
  status: 'pending' | 'in_progress' | 'completed';
}

const IndexTaskPage: React.FC = () => {
  const navigate = useNavigate();
  const [tasks] = useState<Task[]>([
    {
      id: '1',
      title: '宝马汽车4S店高级销售模拟训练模拟训练...',
      description: 'AI对练名称AI对练名称AI对练AI对练AI对练AI对练AI对练AI对练AI...',
      dateRange: '2025-01-01～2025-01-02',
      image: '/api/placeholder/400/200',
      status: 'pending'
    },
    {
      id: '2',
      title: 'AI对练名称AI对练名称AI对练名称',
      description: 'AI对练名称AI对练名称AI对练名称',
      dateRange: '2025-01-01～2025-01-02',
      image: '/api/placeholder/400/200',
      status: 'in_progress'
    },
    {
      id: '3',
      title: 'AI对练名称AI对练名称',
      description: 'AI对练名称AI对练名称',
      dateRange: '2025-01-01～2025-01-02',
      image: '/api/placeholder/400/200',
      status: 'pending'
    }
  ]);

  const [activeTab, setActiveTab] = useState<'未开始' | '进行中' | '已过期'>('进行中');

  const filteredTasks = tasks.filter(task => {
    switch (activeTab) {
      case '未开始':
        return task.status === 'pending';
      case '进行中':
        return task.status === 'in_progress';
      case '已过期':
        return task.status === 'completed';
      default:
        return true;
    }
  });

  return (
    <div className="min-h-screen bg-[#F6F8FA]">
      <TopStatusBar />
      <TopAiHelloCard />
      <UrgentTaskCard style={{ top: '-100px' }} />
      <ToAdminFixedBtn />
    </div>
  );
};



export default IndexTaskPage;